'use client';

import type { FC, JSX } from 'react';
import React from 'react';
import type { ApiProductWithReviews, ApiReview } from '@ibe/api';
import dynamic from 'next/dynamic';
const ProductReviewsCompact = dynamic(
  () => import('@/components/ProductReviewsCompact/ProductReviewsCompact')
);

const ProductReviewsCompactWrapper: FC<{
  reviews?: Omit<ApiProductWithReviews, 'reviews'> & { reviews?: Partial<ApiReview>[] };
  themeReviews?: string;
}> = (props): JSX.Element => {
  return <ProductReviewsCompact {...props} />;
};

export default ProductReviewsCompactWrapper;
